import React, { Fragment, useCallback, } from 'react';
import Box from '@material-ui/core/Box';

import { repositories, } from 'api';
import { pages, } from 'styles';

type Props = {
    type: repositories.products.CollectionTypes.ProductsProductItemType,
    attributes: Array<repositories.products.CollectionTypes.ProductsAttributeType>,
    shortDescription: string,
};

const bookOrderAttributes = [
    repositories.products.CollectionTypes.ATTRIBUTES_CODES_MAP.BOOK_AUTHOR,
    repositories.products.CollectionTypes.ATTRIBUTES_CODES_MAP.SCHOOL_SUBJECTS,
    repositories.products.CollectionTypes.ATTRIBUTES_CODES_MAP.SCHOOL_LEVEL,
    repositories.products.CollectionTypes.ATTRIBUTES_CODES_MAP.BOOK_TYPES,
];

const prepareBookAttributes = (data: Array<repositories.products.CollectionTypes.ProductsAttributeType>) => bookOrderAttributes.reduce((
    attributes: Array<repositories.products.CollectionTypes.ProductsAttributeType>,
    code: string
) => {
    const found = data.find(item => item.code === code);

    return found ? [ ...attributes, found, ] : attributes;
}, []);

const ProductsItemAttributes: React.FC<Props> = ({
    type,
    attributes,
    shortDescription,
}) => {
    const attributesListStyle = pages.products.makeProductsItemAttributesStyles();
    const shortDescriptionStyles = pages.products.makeShortDescriptionStyles();

    const renderBookAttributes = useCallback(({
        code,
        value,
        name,
    }: repositories.products.CollectionTypes.ProductsAttributeType) => (
        <Fragment key={code}>
            <dt className={attributesListStyle.name}>{name.toLowerCase()}</dt>
            <dd className={attributesListStyle.value}>{value}</dd>
        </Fragment>
    ), [ attributesListStyle, ]);

    switch (type) {
        case repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.BOOK:
            const selectedAttributes = prepareBookAttributes(attributes);

            return (
                <dl className={attributesListStyle.list}>
                    {selectedAttributes.map(renderBookAttributes)}
                </dl>
            );

        case repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.GRANT_APP:
        case repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.GRANT_SET:
            return (
                <Box mx={{ xs: 2, md: 0, }}
                     className={ shortDescriptionStyles.root }
                     dangerouslySetInnerHTML={{ __html: shortDescription, }} />
            );

        default:
            return null;
    }
};

export default ProductsItemAttributes;
